export function BarbellIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Bar */}
      <path d="M4 12h16" />
      {/* Left plates */}
      <rect x={3} y={9} width={1.5} height={6} rx={0.3} />
      <rect x={5} y={8} width={1.6} height={8} rx={0.3} />
      {/* Right plates */}
      <rect x={19.5} y={9} width={1.5} height={6} rx={0.3} />
      <rect x={17.4} y={8} width={1.6} height={8} rx={0.3} />
    </svg>
  );
}



